import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { BodyPatchResponseRelation, BodyPostCampusRelation, ResponseCampusRelationId, ResponseGetCampusRealtionId, ResponseGetCampusRelation, ResponsePatchCampusRelation, ResponsePostCampusRelation } from "./interfaceCampusDetail";



export const getCampusRelation = async (): Promise<ResponseGetCampusRelation[]> => {
    try {
        const data = await getApi('/campus');
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetCampusRelation[];
    }
}


export const getCampusRelationYear = async (year?: string): Promise<ResponseGetCampusRelation[]> => {
    try {
        const data = await getApi(`/campus/year/${year}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetCampusRelation[];
    }
}


export const getSedes = async (year?: string): Promise<ResponseGetCampusRelation[]> => {
    try {
        const data = await getApi(`/campus/year/${year}/open`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetCampusRelation[];
    }
}





export const postCampusRelation = async (body: any, id?: any): Promise<ResponsePostCampusRelation> => {
    try {
        const data = await postApi('/campus', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePostCampusRelation;
    }
}


export const patchCampusRelation = async (body: any, id?: number): Promise<ResponsePatchCampusRelation> => {

    try {
        const data = await patchApi(`/campus/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePatchCampusRelation;
    }
}


export const getCampusRelationId = async (term?: number): Promise<ResponseCampusRelationId> => {
    try {
        const data = await getApi(`/campus/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseCampusRelationId;
    }
}


export const deleteCampusRelation = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/campus/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}